<template>
  <!-- Barra de progreso fina: pista gris + relleno coloreado (ancho = valor %, tope 100). -->
  <span class="bar">
    <span class="bar-fill" :style="{ width: width, background: color }"></span>
  </span>
</template>

<script>
  export default {
    name: 'PrmDashBar',

    props: {
      value: { type: Number, default: 0 }, // 0-100
      color: { type: String, default: '#3a6bc8' },
    },

    computed: {
      width () {
        return Math.max(0, Math.min(Number(this.value) || 0, 100)) + '%'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bar { display: block; width: 100%; height: 6px; border-radius: 999px; background: #e9edf2; overflow: hidden; }
  .bar-fill { display: block; height: 100%; border-radius: 999px; }
</style>
